import { fetchArticleData, fetchArticles, fetchArticleMapData } from "actions/fetch";
import { updateArticleData } from "actions/data.js";

import { mergeEntityFilters, pluckActiveFilters } from "@exo/helpers";
import { makeFetchKey } from "lib/helpers/helpers.js";
import { 
	formatQueryAddsForPost,
	formatQueryExcludesForPost,
	formatHierarchyFiltersForPost, 
} from "lib/helpers/filterHelpers.js";
import { setActiveChatConfig, clearForceSingleDocChatDisplay } from 'actions/chatActions';
import { DATASET_ID_NARRATIVES } from 'layout/DataExplorer/DataExplorerConstants.js';

import { SEARCH_STATE_IDS } from "actions/constants/stateIds.js";

const stateId = SEARCH_STATE_IDS.NARRATIVES;

// Content Modal
// Pick TwitterModal or ExpandedContentModal
export function openContentModal(dataset, content, event) {
	// console.log("openContentModal", content, event);

	return (dispatch) => {
		if (content.type === "twitter") {
			dispatch(openTwitterModal(content, event));
		} else {
			dispatch(openExpandedContentModal(dataset, content, event));
		}
	};
}

export function openTwitterModal(content, event) {
	return (dispatch, getState) => {
		// const { offsetX, offsetY } = event.nativeEvent;
		const { offsetWidth, offsetHeight } = event.nativeEvent.target;
		const offsetY = event.nativeEvent.pageY;
		const { windowSize } = getState().base;

		// This starts the spinner
		dispatch({ type: "sizeTwitterModal", offsetY, offsetWidth, offsetHeight, windowSize });
		dispatch({ type: "setTwitterCard", content });

		// delay so that the modal position is set first
		setTimeout(() => {
			dispatch({ type: "openTwitterModal" });
		}, 10);
	};
}

export function setGoogleTranslateLang(params) {
	const {name, id} = params;
	return (dispatch, getState) => {
		const { selectedGoogleTranslateLang }  = getState().expandedContent;
		if (!selectedGoogleTranslateLang || (selectedGoogleTranslateLang.name !== name && selectedGoogleTranslateLang.id !== id)) {
			dispatch({
				type:"selectGoogleLang",
				name,
				id,
			})
		}
	}
}

export function openExpandedContentModal(dataset, content, event) {
	return (dispatch, getState) => {
		// const { offsetX, offsetY } = event.nativeEvent;
		const { offsetWidth, offsetHeight } = event.nativeEvent.target;
		const offsetY = event.nativeEvent.pageY;
		const { windowSize } = getState().base;

		// Initialize single doc chat config if opening without any pre-loaded config
		const { activeConfigs } = getState().chat;
		if (!activeConfigs["single"]) {
			dispatch(setActiveChatConfig("single", {dataset}));
		}

		// This starts the spinner
		dispatch({ type: "sizeContentModal", offsetY, offsetWidth, offsetHeight, windowSize });
		dispatch(fetchArticleData(content));

		// delay so that the modal position is set first
		setTimeout(() => {
			dispatch({ type: "openContentModal" });
		}, 10);
	};
}
export function closeContentModal() {
	return (dispatch, getState) => {
		dispatch(clearForceSingleDocChatDisplay());
		dispatch(setActiveChatConfig("single", null));
		dispatch({type: "closeContentModal"});
	};
}
export function closeTwitterModal() {
	return {
		type: "closeTwitterModal",
	};
}

//  Map hover
//    Using a delay because onMouseEnter and onMouseLeave fire at the same time.
//    onMouseEnter must resolve second.
export function hoverContentMap(data, color, startDate, endDate) {
	// console.log('hoverMap', data);
	return (dispatch) => {
		setTimeout(() => {
			dispatch({
				type: "hoverContentMap",
				data,
				color,
				startDate,
				endDate,
			});
		}, 10);
	};
}
export function unhoverContentMap() {
	return {
		type: "unhoverContentMap",
	};
}

export function clickContentMap(data, narrative, color, startDate, endDate, isHighlighted, perspective) {
	console.log("clickContentMap", data, narrative, color, startDate, endDate, isHighlighted, perspective);

	return (dispatch, getState) => {
		const articleID = getState().expandedContent.expandedContent.uuid;
		if (!isHighlighted) {
			dispatch({ type: "contentMapDataLoading", topShares: data.shares }); // starts spinner
			dispatch(highlightContentMap(data, color));
			dispatch(fetchArticleMapData(data.geoState, articleID));
		}
	};
}

export function highlightContentMap(data, color) {
	return {
		type: "highlightContentMap",
		data,
		color,
	};
}

export function clearContentMap() {
	return {
		type: "clearContentMapHighlight",
	};
}

export const toggleDuplicates = () => {
	return (dispatch, getState) => {
		const { showDuplicates } = getState().base;
		dispatch(
			updateArticleData({
				showDuplicates: !showDuplicates,
			})
		);
		dispatch({
			type: "toggleDuplicates",
			showDuplicates: !showDuplicates,
		});
	};
};

export const updateContentByHeader = (header, pageLength, offset) => {
	const getDefaultSortAscending = () => {
		switch (header.id) {
			case "date":
			case "fdate":
			case "shares":
			case "dupCount":
				return false;
			default:
				return true;
		}
	}
	return (dispatch, getState) => {
		// dispatch({ type: "requestArticles" });
		const {
			activeNarrativeData,
			contentFilteredByDate,
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			entityFilters,
			filtersList,
			perspective,
			showDuplicates,
			relevancy,
		} = getState().base;

		const { 
			filters, 
			currentFiltersList,
			activeSearchObj,
			currentZoom,
		} = getState().search[stateId]

		const startDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin;
		const endDate = contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end;

		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;
		
		// Derive the filters and query terms to be sent 
		const query = (activeSearchObj.query && activeSearchObj.query.length > 0) ? activeSearchObj.query : undefined;
		const formattedFilters = formatHierarchyFiltersForPost(filters);
		const queryAdd = formatQueryAddsForPost(currentFiltersList);
		const queryExclude = formatQueryExcludesForPost(currentFiltersList);
		const mergedFilters = formattedFilters;

		// REVISIT JA: REMOVE
		// const activeFilters = pluckActiveFilters(filtersList);
		// const mergedFilters = mergeEntityFilters({
		// 	activeFilters,
		// 	entityFilters,
		// 	keywords: activeKeywords,
		// 	perspective,
		// });

		// Derive the sort type for content 
		const ascending = !header 
		? contentHeaderSortAscending 
		: (header.id === contentHeaderSortType) 
			? !contentHeaderSortAscending 
			: getDefaultSortAscending();

		const fetchKey = makeFetchKey(activeNarrativeData, perspective, formattedFilters, currentZoom);
		dispatch({ type: "mostRecentFetch", fetchKey });

		dispatch(
			fetchArticles({
				narrative: activeNarrativeData,
				perspective,
				startDate,
				endDate,
				filters: formattedFilters,
				currentFilters: mergedFilters || [],
				fetchKey,
				showDuplicates,
				sortBy: header ? header.id : contentHeaderSortType,
				ascending,
				relevancy,
				pageLength,
				query,
				queryAdd,
				queryExclude,
				offset,
			})
		);
		if (header) {
			dispatch({	
				type: "setContentSort",
				sortBy: header.id,
				ascending,
				perspective,
			});
		}
	};
};

// export function receiveContentExport() {
// 	console.log("receiveContentExport");
// 	// TODO: Write this
// 	return {
// 		type: "receiveContentExport",
// 	};
// }
